<template>
  <div style="height: 66vh">
    <!-- Banner Area Starts -->
    <section class="banner-area">
      <div class="container-fluid">
        <div class="row">
          <div class="col-lg-6 px-0">
            <div class="banner-bg"></div>
          </div>
          <div class="col-lg-6 align-self-center fadeIn animated">
            <div class="banner-text">
              <h1 style="text-align: center;">{{ text.title }}</h1>
              <p class="py-3 text-line">
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ text.content }}
              </p>
              <!-- <a href="#" class="secondary-btn">explore now<span class="flaticon-next"></span></a> -->
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- Banner Area End -->

    <!-- Search Area Starts -->
    <!-- <div class="search-area">
      <div class="search-bg">
        <div class="container">
          <div class="row">
            <div class="col-lg-12">
              <form action="#" class="d-md-flex justify-content-between">
                <select>
                  <option value="1">All Category</option>
                  <option value="2">Part Time</option>
                  <option value="3">Full Time</option>
                  <option value="4">Remote</option>
                  <option value="5">Office Job</option>
                </select>
                <select>
                  <option value="1">Select Location</option>
                  <option value="2">Dhaka</option>
                  <option value="3">Rajshahi</option>
                  <option value="4">Barishal</option>
                  <option value="5">Noakhali</option>
                </select>
                <input type="text" placeholder="Search Keyword" onfocus="this.placeholder = ''"
                       onblur="this.placeholder = 'Search Keyword'" required>
                <button type="submit" class="template-btn">find job</button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <!-- Search Area End -->



  </div>
</template>

<script>
export default {

  data () {
    return {
      text: {
        title: '宜昌市艾福斯信息咨询有限责任公司',
        content: '立足于先进的ERP软件、国产自主可控数据库、开源软件技术和研发工具，始终以“满足用户需求”为服务宗旨，致力于为资产密集型及项目管理型企业设计开发数字化全面解决方案，解决方案吸纳了国外大型ERP软件的管理思想和结合了中国企业的管理特点，包括完整的应用软件程序系统、业务流程标准库、信息资源管理基础标准库、报表库和配套的系统实施开发方法。经过20多年的技术研发积累和项目实施开发经验打磨，公司的核心技术与服务团队不仅具有丰富的能源电力行业管理数字化和信息技术专业知识，而且具备与国际接轨的大型软件项目实施开发的项目管理经验。'
      }
    }
  }
}
</script>

<style scoped>
.py-3 {
  color: black;
}

.banner-bg {
  /* height: 588px; */
  /* height: 597px; */
  height: 100%;
}
.banner-area{
  height: 100%;
}
.banner-area .banner-text {
  padding: 0 10% 0 5%;
}

.text-line {
  line-height: 65px;
}
.container-fluid{
  height: 100%;
}
.row{
  height: 100%;
}
</style>




// WEBPACK FOOTER //
// Home.vue?c2ba53d4